import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialBcfState = {
  currentBcfId: "",
  bcfData: null,
  isAutoBcfLoaded: false,
};

const itemsHaveErrorSlice = createSlice({
  name: "itemsHaveError",
  initialState: false,
  reducers: {
    setItemsHaveError: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const itemsAreLoadingSlice = createSlice({
  name: "itemsAreLoading",
  initialState: false,
  reducers: {
    setItemsAreLoading: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const itemsSlice = createSlice({
  name: "items",
  initialState: [],
  reducers: {
    setItems: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const bcfDataSlice = createSlice({
  name: "bcfData",
  initialState: initialBcfState,
  reducers: {
    saveBcfData: (state: any, action: PayloadAction<any>) => {
      if (action.payload) {
        state.currentBcfId = action.payload;
      }
    },
    setBcfBufferData: (state: any, action: PayloadAction<any>) => {
      if (action.payload) {
        state.bcfData = action.payload;
      }
    },
    setAutoBcfLoaded: (state: any, action: PayloadAction<any>) => {
      if (action.payload !== undefined) {
        state.isAutoBcfLoaded = action.payload;
      }
    },
  },
});

export const { setItemsHaveError } = itemsHaveErrorSlice.actions;
export const { setItemsAreLoading } = itemsAreLoadingSlice.actions;
export const { setItems } = itemsSlice.actions;
export const { saveBcfData, setBcfBufferData, setAutoBcfLoaded } = bcfDataSlice.actions;

export const itemsHaveError = itemsHaveErrorSlice.reducer;
export const itemsAreLoading = itemsAreLoadingSlice.reducer;
export const items = itemsSlice.reducer;
export const bcfData = bcfDataSlice.reducer;
